import useAffiliateConfig from "../../hooks/useAffiliateConfig";
import useAppSelector from "../../hooks/useAppSelector";
import { useMemo } from "react";
export default function useCanShowMidFunnelAds() {
    var _a = useAppSelector(function (state) { return state.configuration; }), isSavvyWidget = _a.isSavvyWidget, policyOnly = _a.policyOnly;
    var affiliateConfig = useAffiliateConfig();
    return useMemo(function () {
        return isSavvyWidget === true &&
            policyOnly === false &&
            affiliateConfig.quotesOnly === false;
    }, [isSavvyWidget, policyOnly, affiliateConfig.quotesOnly]);
}
